import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

/**
 * Returns the Set of `user_items.id` values that have an active or pending
 * `ebay_listings` row for the current user. Shared across inventory cards +
 * list rows so every tile gets the "also on eBay" indicator without N queries.
 */
export function useMyActiveEbayItemIds() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['my-active-ebay-item-ids', user?.id],
    enabled: !!user?.id,
    staleTime: 60_000,
    queryFn: async (): Promise<Set<string>> => {
      const { data, error } = await (supabase as any)
        .from('ebay_listings')
        .select('item_id,status')
        .eq('user_id', user!.id)
        .in('status', ['active', 'pending']);
      if (error) throw error;
      return new Set(((data as any[]) ?? []).map((r) => r.item_id as string));
    },
  });
}

export function useHasActiveEbayListing(itemId: string): boolean {
  const { data } = useMyActiveEbayItemIds();
  return !!data?.has(itemId);
}
